import React from 'react'
import { GlassButton } from './Glass'
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded'
import { SxProps } from '@mui/material/styles'

export default function PlayButton({
  size,
  disabled,
  onClick,
  sx,
}: {
  size?: 'sm' | 'md' | 'lg'
  disabled?: boolean
  onClick?: () => void
  sx?: SxProps
}): JSX.Element {
  return (
    <GlassButton
      disabled={disabled}
      variant="contained"
      onClick={onClick}
      size="large"
      endIcon={<PlayArrowRoundedIcon />}
      sx={{
        minHeight: size === 'sm' ? 42 : 52,
        px: 4,
        fontSize: 18,
        width: { xs: '100%', sm: 'auto' },
        ...sx,
      }}
    >
      Play
    </GlassButton>
  )
}
